import { useIntl } from 'react-intl';

import Image from '@/components/image/NextImage';
import { useAnalytics } from '@/hooks/analytics';

import messages from './messages';
import * as Styled from './styles';

const YearOfCalm = () => {
	const { formatMessage } = useIntl();
	const { logEvent } = useAnalytics();

	return (
		<Styled.Wrapper>
			<Styled.Column>
				<Image
					layout="fill"
					src="/_n/images/calm-box/gift-card-image.webp"
					alt="Woman holding a gift certificate for a year of Calm Premium and smiling"
					objectFit="cover"
				/>
			</Styled.Column>
			<Styled.Column>
				<Styled.Heading>{formatMessage(messages.header)}</Styled.Heading>
				<Styled.Copy>{formatMessage(messages.description)}</Styled.Copy>
				<Styled.ButtonWrapper>
					<Styled.StyledButton
						backgroundColor="white"
						textColor="black"
						onPress={() => {
							logEvent({
								eventName: 'Gift : CTA : Clicked',
								eventProps: {
									slug: '/gift',
									section: 'Gift a Calm Subscription',
									copy: 'Send a Gift Card',
									type: 'button',
								},
							});
						}}
						href="/gift-card"
						openInNewTab
					>
						{formatMessage(messages.buttonCta)}
					</Styled.StyledButton>
					<Styled.StyledButton
						backgroundColor="white"
						textColor="black"
						onPress={() => {
							logEvent({
								eventName: 'Gift : CTA : Clicked',
								eventProps: {
									slug: '/gift',
									section: 'Gift a Calm Subscription',
									copy: 'Send a lifetime membership',
									type: 'button',
								},
							});
						}}
						href="/lifetime-gift-card"
						openInNewTab
					>
						{formatMessage(messages.lifetimeButtonCta)}
					</Styled.StyledButton>
				</Styled.ButtonWrapper>
			</Styled.Column>
		</Styled.Wrapper>
	);
};

export default YearOfCalm;
